import React from 'react';
import HonorCardEmailForm from './ehonor-card-email-form';
import HonorCardProductDetail from './ehonor-card-product-detail';
import WVForm from './form';

export default class HonorCardEmailInfo extends React.Component {
	constructor(props) {
    	super(props);
	}

	render() {
		const productDisplay = this.props.selectedProduct ? <HonorCardProductDetail selectedProduct={this.props.selectedProduct}></HonorCardProductDetail> : null;

		return (
			<div>
				{ productDisplay }
				<WVForm {...this.props} innerForm={HonorCardEmailForm}></WVForm>
			</div>
		);
	}
}